/** @jsx jsx */
import { h, FunctionalComponent } from 'preact'
import { jsx } from '@emotion/core'

import { getStylesObject } from './threeImageLinks.styles'
import { useSiteVars } from '../../themes/useSiteVars'

interface ThreeImageLinksProps {
    linkAUrl: string
    linkATitle: string
    linkAImage: string
    linkBUrl?: string
    linkBTitle?: string
    linkBImage?: string
    linkCUrl?: string
    linkCTitle?: string
    linkCImage?: string
    preview?: boolean
}

const ThreeImageLinks: FunctionalComponent<ThreeImageLinksProps> = ({
    linkAUrl,
    linkATitle,
    linkAImage,
    linkBUrl,
    linkBTitle,
    linkBImage,
    linkCUrl,
    linkCTitle,
    linkCImage,
    preview = false,
}) => {
    const siteVars = useSiteVars()
    const styles = getStylesObject(siteVars, preview)
    const shouldRenderSecondImage = linkBUrl && linkBTitle && linkBImage
    const shouldRenderThridImage = linkCUrl && linkCTitle && linkCImage
    return (
        <div css={styles.container}>
            <div css={styles.childContainer}>
                <a href={linkAUrl} target="_top">
                    <img css={styles.image} src={linkAImage} alt={linkATitle} />
                    <h2 css={styles.text}>{linkATitle}</h2>
                    <div css={styles.line} />
                    <div css={styles.gradient} />
                </a>
            </div>
            {shouldRenderSecondImage && (
                <div css={styles.middleContainer}>
                    <a href={linkBUrl} target="_top">
                        <img css={styles.image} src={linkBImage} alt={linkBTitle} />
                        <h2 css={styles.text}>{linkBTitle}</h2>
                        <div css={styles.line} />
                        <div css={styles.gradient} />
                    </a>
                </div>
            )}
            {shouldRenderThridImage && (
                <div css={styles.childContainer}>
                    <a href={linkCUrl} target="_top">
                        <img css={styles.image} src={linkCImage} alt={linkCTitle} />
                        <h2 css={styles.text}>{linkCTitle}</h2>
                        <div css={styles.line} />
                        <div css={styles.gradient} />
                    </a>
                </div>
            )}
        </div>
    )
}

export default ThreeImageLinks
